<script setup>
import { useI18n } from 'vue-i18n'

import AppleSvg from '@/components/svg/AppleSvg.vue'
import GooglePlaySvg from '@/components/svg/GooglePlaySvg.vue'

import OpineoPlSvg from '@/components/svg/footer/media/pl/OpineoPlSvg.vue'
import ShopRokuSvg from '@/components/svg/footer/media/ShopRokuSvg.vue'
import MediaSvg from '@/components/svg/footer/MediaSvg.vue'
import ZacinajiciPodnikatelSvg from '@/components/svg/footer/media/ZacinajiciPodnikatelSvg.vue'
import FooterAnpc from "@/components/footer/FooterAnpc.vue";

const { t, locale } = useI18n()
</script>

<template>
  <div class="row mx-0 px-0 items-start">
    <div class="flex ml-n1 sm:ml-0">
      <a
        href="https://apps.apple.com/cz/app/mixit/id6444029029"
        class="no-decoration flex btn btn-outline-light border-1 rounded-pill font-bold footer-app-link text-md sm:mr-2 mr-1 text-left"
        target="_blank"
      >
        <span class="app-link-icon flex border border-light border-1 items-center justify-center rounded-circle mr-2">
          <AppleSvg class="i-apple" />
        </span>
        App Store
      </a>
      <a
        href="https://play.google.com/store/apps/details?id=cz.mixit.app"
        class="no-decoration flex btn btn-outline-light border-1 rounded-pill font-bold footer-app-link text-md text-left"
        target="_blank"
      >
        <span class="app-link-icon flex border border-light border-1 items-center justify-center rounded-circle mr-2">
          <GooglePlaySvg />
        </span>
        Google Play
      </a>
    </div>
    <div class="lg:ml-auto col-12 lg:col-auto">
      <ul class="row list-unstyled ml-n4 mb-0">
        <li
          v-if="locale === 'cs' || locale === 'sk'"
          class="col-auto pr-5 flex lg:mt-0 mt-5"
        >
          <span class="mt-2">
            <MediaSvg
              width="34"
              height="29"
            />
          </span>
          <div class="pl-2 text-primary-100">
            <span class="font-bold block text-md mt-1">{{ t('what_media_wrote_about_us') }}</span>
            <router-link
              :to="{ name: 'mediaPath' }"
              aria-label="Media"
              class="mt-2"
            >
              {{ t('go_to_articles') }}
            </router-link>
          </div>
        </li>
        <li
          v-if="locale === 'cs' || locale === 'sk'"
          class="col-auto pr-5 lg:mt-0 mt-5"
        >
          <ShopRokuSvg
            width="162"
            height="50"
          />
        </li>
        <li
          v-if="locale === 'cs' || locale === 'sk'"
          class="col-auto pr-0 lg:mt-0 mt-5"
        >
          <ZacinajiciPodnikatelSvg
            width="147"
            height="50"
          />
        </li>
        <li
          v-if="locale === 'pl'"
          class="col-auto pl-5 pr-0"
        >
          <OpineoPlSvg
            width="65"
            height="60"
          />
        </li>
        <li
          v-if="locale === 'ro'"
          class="col-auto pr-0 lg:mt-0 mt-5"
        >
          <FooterAnpc />
        </li>
      </ul>
    </div>
  </div>
</template>

<style lang="scss">
.footer-app-link {
  padding: 5px 16px 5px 5px;

  &:hover {
    .app-link-icon {
      background-color: $primary;
    }
  }

  .app-link-icon {
    width: 30px;
    height: 30px;
    background-color: #ee9e3e4d;
    transition: .15s background-color;

    .i-apple {
      margin-top: -1px;
    }
  }
}
</style>

<i18n>
  {
    "cs": {
    "go_to_articles": "Jít na články",
    "what_media_wrote_about_us": "Co o nás píší média?"
},
    "sk": {
    "go_to_articles": "Prezerať médiá o nás",
    "what_media_wrote_about_us": "Čo o nás hovoria médiá?"
},
    "pl": {
    "go_to_articles": "Przejdź do artykułów",
    "what_media_wrote_about_us": "Co mówią o nas media?"
},
    "hu": {
    "go_to_articles": "Ugrás a cikkekhez",
    "what_media_wrote_about_us": "Mit ír rólunk a média?"
},
    "de": {
    "go_to_articles": "zum Artikel",
    "what_media_wrote_about_us": "Was schreiben die Medien über uns?"
},
    "at": {
    "go_to_articles": "zum Artikel",
    "what_media_wrote_about_us": "Was schreiben die Medien über uns?"
},
    "ro": {
    "go_to_articles": "Accesați articole",
    "what_media_wrote_about_us": "Ce scrie mass-media despre noi?"
},
    "fr": {
    "go_to_articles": "Accéder aux articles",
    "what_media_wrote_about_us": "Dans les médias."
}
  }
</i18n>

